<work-view
  [backlogTasks]="workContextService.backlogTasks$|async"
  [doneTasks]="workContextService.doneTasks$|async"
  [isShowBacklog]="true"
  [undoneTasks]="workContextService.undoneTasks$|async"
></work-view>
